<template lang="pug">
RulerOverlayLayer(v-if="module.persistent.show", :module="module", :mode="mode", :tic.sync="frameStore.tic")
</template>

<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { RulerModule } from '.';
import RulerOverlayLayer from "./RulerOverlayLayer";
import { store } from '../../store';
import { FrameStore } from '../base';

@Component({
  components: {
    RulerOverlayLayer,
  },
})
export default class extends Vue {
  @Prop({ required: true })
  module!: RulerModule

  @Prop({ required: true })
  frameStore!: FrameStore<typeof RulerModule>

  get mode() {
    return store.modules.coordIndicator.coordFormat
  }
}
</script>
